import { formatBirthday } from 'helpers/time';

const vendorSpecificProperties = [
  'animation',
  'animationDelay',
  'animationDirection',
  'animationDuration',
  'animationFillMode',
  'animationIterationCount',
  'animationName',
  'animationPlayState',
  'animationTimingFunction',
  'transform',
  'transformOrigin',
  'transformStyle',
  'transition',
  'transitionDelay',
  'transitionDuration',
  'transitionProperty',
  'transitionTimingFunction',
];

const prefix = (() => {
  const styles = window.getComputedStyle(document.documentElement);

  const prefixString = Array.prototype.slice.call(styles).join('');
  const standardPrefixString = prefixString.match(/-(moz|webkit|ms)-/);
  const operaPrefixString = prefixString.match(styles.OLink === '' && ['', 'o']);
  const prefixMatch = standardPrefixString || operaPrefixString;

  let prefix = prefixMatch ? prefixMatch[1] : '';

  if (prefix !== 'ms') {
    prefix = `${prefix.charAt(0).toUpperCase()}${prefix.slice(1)}`;
  }

  return prefix || '';
})();

const STRING_TO_CAMEL = /-([a-z])/g;
export const dashToCamelCase = s => s.replace(STRING_TO_CAMEL, g => g[1].toUpperCase());

export const randomString = (length = 10) =>
  (
    Math.random()
      .toString(36)
      .substring(2, 2 + length) + '0'.repeat(length)
  ).substring(0, length);

export const prefixed = key => {
  if (vendorSpecificProperties.indexOf(key) > -1) {
    return prefix + key[0].toUpperCase() + key.substr(1);
  }

  return key;
};

export const stringToCSSObject = string => {
  const style = {};

  try {
    const css = string.split('\n');
    css.forEach(value => {
      if (value) {
        const [k, v] = value.split(':');
        const key = prefixed(dashToCamelCase(k));

        style[key] = v.replace(';', '');
      }
    });
  } catch (e) {
    pe(e, `"${string}" could not be converted to CSS`);
  }

  return style;
};

export const transformWithPrefix = prefix ? prefix + 'Transform' : 'transform';

export const specialText = (text, name, birthday, options) => {
  const placeholder = options.get('placeholder_text');
  const specialType = options.getIn(['special_text', 'special_text'], false);
  const date_format = `D${kroostApp.language === 'de' ? '.' : ''} MMMM YYYY`;

  let _text = text || '';
  if (typeof text === 'undefined') {
    _text = (placeholder || '')
      .replace(/{name}/gi, name)
      .replace(/{birthday}/gi, formatBirthday(birthday, date_format));
  }

  if (specialType === 'name') {
    _text = name;
  } else if (specialType === 'birthday') {
    _text = formatBirthday(birthday, date_format);
  } else if (specialType === 'name_first_letter') {
    _text = name[0];
  }

  return _text;
};



// WEBPACK FOOTER //
// ./app/helpers/string.js